// extracted by mini-css-extract-plugin
var _1 = "PLf6o";
var _2 = "OznQ4";
export { _1 as "name", _2 as "title" }
